import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ScopedCssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import theme from "./theme";
import tokens from "./theme/tokens";

const { color } = tokens;

/**
 * Theme boundary for everything under /v1.
 *
 * The console's theme is deliberately NOT applied at App level: the old UI is still
 * shipping and must keep its Raleway/blue look untouched until /v1 reaches parity.
 * ScopedCssBaseline (rather than CssBaseline) applies the baseline to this subtree
 * only — it never touches <body>, so nothing here can bleed into the old pages.
 */
const V1Theme = () => (
  <ThemeProvider theme={theme}>
    <ScopedCssBaseline sx={{ bgcolor: color.bg, minHeight: "100vh" }}>
      <Outlet />
    </ScopedCssBaseline>
  </ThemeProvider>
);

export default V1Theme;
